module.exports = __webpack_public_path__ + "img/general-hospital-logo.b4ebdcb2.png";